import api from "@/api";
import esupplyvetApi from "@/api/esupplyvet";
import { useRegisterStore } from "@/stores/register";

function getHttpClient() {
  const registerStore = useRegisterStore();
  const userRole = registerStore.user?.role || "";
  return userRole === "client" ? esupplyvetApi : api;
}

/**
 * Service pour la gestion des animaux
 */
export const animalsService = {
  /**
   * Récupère la liste des animaux de l'utilisateur connecté
   * @returns {Promise} Promesse contenant la liste des animaux
   */
  async getAnimals() {
    try {
      const response = await getHttpClient().get("/animals");
      return response.data;
    } catch (error) {
      console.error("Erreur lors de la récupération des animaux:", error);
      throw error;
    }
  },

  /**
   * Récupère la liste des types d'animaux
   * @returns {Promise} Promesse contenant la liste des types d'animaux
   */
  async getAnimalTypes() {
    try {
      const response = await getHttpClient().get("/animal-types");
      return response.data;
    } catch (error) {
      console.error("Erreur lors de la récupération des types d'animaux:", error);
      throw error;
    }
  },

  /**
   * Récupère la liste des races d'animaux
   * @returns {Promise} Promesse contenant la liste des races d'animaux
   */
  async getAnimalRaces() {
    try {
      const response = await getHttpClient().get("/animal-races");
      return response.data;
    } catch (error) {
      console.error("Erreur lors de la récupération des races d'animaux:", error);
      throw error;
    }
  },

  /**
   * Récupère un animal par son ID
   * @param {number|string} id - L'ID de l'animal à récupérer
   * @returns {Promise} Promesse contenant les données de l'animal
   */
  async getAnimal(id) {
    try {
      const response = await getHttpClient().get(`/animals/${id}`);
      return response.data;
    } catch (error) {
      console.error("Erreur lors de la récupération de l'animal:", error);
      throw error;
    }
  },

  /**
   * Crée un nouvel animal
   * @param {Object} animalData - Les données de l'animal à créer
   * @returns {Promise} Promesse contenant les données du nouvel animal
   */
  async createAnimal(animalData) {
    try {
      const response = await getHttpClient().post("/animals", animalData);
      return response.data;
    } catch (error) {
      console.error("Erreur lors de la création de l'animal:", error);
      throw error;
    }
  },

  /**
   * Met à jour un animal par son ID
   * @param {number|string} id - L'ID de l'animal à mettre à jour
   * @param {Object} animalData - Les données de l'animal à mettre à jour
   * @returns {Promise} Promesse contenant les données mises à jour
   */
  async updateAnimal(id, animalData) {
    try {
      const response = await getHttpClient().put(`/animals/${id}`, animalData);
      return response.data;
    } catch (error) {
      console.error("Erreur lors de la mise à jour de l'animal:", error);
      throw error;
    }
  },

  /**
   * Supprime un animal par son ID
   * @param {number|string} id - L'ID de l'animal à supprimer
   * @returns {Promise} Promesse de suppression
   */
  async deleteAnimal(id) {
    try {
      const response = await getHttpClient().delete(`/animals/${id}`);
      return response.data;
    } catch (error) {
      console.error("Erreur lors de la suppression de l'animal:", error);
      throw error;
    }
  },
};
